import { UPDATE_CURRENT_USER } from "../constants/action-types";

const initialState = {
  current_user: {}
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CURRENT_USER:
      return { ...state, current_user: action.payload.user };
    default:
      return state;
  }
}

export default userReducer;
